<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi1"><a id="page_iv"><span class="txit">For all those who have trouble at home.</span></a></p><a id="page_iv">
<p class="dedi"><span class="txit">You are not alone.</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?26ccc282